/**
 * `crypto.randomUUID()` is only exposed to browsers in secure contexts
 * (HTTPS or localhost). Dev hosts served over plain HTTP leave it
 * undefined, which blew up several screens (CreateTenantWizard,
 * DataSources, CohortRuleEditor) with "crypto.randomUUID is not a
 * function". Prefer the native API when available, fall back to an
 * RFC 4122 v4 string derived from `getRandomValues` (or Math.random
 * as a last resort) so insecure dev contexts still work.
 */
export const safeUUID = (): string => {
  const c = (typeof crypto !== 'undefined' ? crypto : undefined) as
    | (Crypto & { randomUUID?: () => string })
    | undefined;
  if (c?.randomUUID) return c.randomUUID();

  const bytes = new Uint8Array(16);
  if (c?.getRandomValues) {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
};
